import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const scopeItems = [
  { icon: "ri-movie-2-line", title: "影片资料库", desc: "收录欧美限制级剧情与文艺影片的类型、导演、主演、片长与剧情介绍等结构化资料。" },
  { icon: "ri-grid-line", title: "分类检索", desc: "按类型、年代、地区与评分区间进行多维度筛选与排序，快速定位想看的内容。" },
  { icon: "ri-newspaper-line", title: "影视资讯", desc: "提供影展资讯、影片推荐、行业动态与深度专题，跟进行业最新进展。" },
  { icon: "ri-lightbulb-line", title: "观看指南", desc: "整理影片看点与观影提示，帮助你在合规前提下了解并欣赏优秀影视作品。" },
];

export default function AboutPage() {
  useDocumentMeta(
    "关于我们 - 欧美三级影视资源与资讯平台",
    "了解欧美三级影视资源与资讯平台的定位、内容范围、联系方式与免责声明。本站专注欧美限制级剧情与文艺影片的资料与资讯展示。",
    "关于欧美三级,平台介绍,联系我们,免责声明,影视资讯平台"
  );

  return (
    <div className="mx-auto max-w-[1240px] px-4 py-6 md:px-6 md:py-8">
      <Breadcrumb items={[{ label: "关于我们" }]} />

      {/* Hero */}
      <section className="relative mt-5 overflow-hidden rounded-lg bg-primary-900 px-6 py-10 md:px-12 md:py-14">
        <div className="relative z-10 max-w-2xl">
          <span className="text-xs font-semibold tracking-widest text-accent-300">ABOUT PLATFORM</span>
          <h1 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-4xl">
            关于欧美三级影视平台
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-primary-100/85 md:text-base">
            欧美三级是一个聚焦欧美限制级剧情与文艺影视作品的资源与资讯平台。我们希望用结构清晰、内容专业的资料，帮助影视爱好者更便捷地查找、浏览影片信息，并获取最新影视动态。
          </p>
        </div>
        <span className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-accent-500/20 blur-2xl"></span>
      </section>

      {/* 定位与内容范围 */}
      <section className="mt-10 md:mt-14">
        <h2 className="flex items-center gap-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-6 w-1 rounded-full bg-accent-500 md:h-7"></span>
          网站定位与内容范围
        </h2>
        <p className="mt-4 max-w-4xl text-sm leading-relaxed text-foreground-700">
          平台以满足用户对欧美影视资源的查找、浏览与资讯获取需求为核心，突出内容的丰富性与专业性。所有影片资料以分类目录的方式组织，配合剧情介绍与影片标签，让浏览者能够快速建立对作品的整体了解。
        </p>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {scopeItems.map((item) => (
            <div
              key={item.title}
              className="flex gap-4 rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-700">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-secondary-500">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 联系方式 */}
      <section className="mt-10 md:mt-14">
        <h2 className="flex items-center gap-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-6 w-1 rounded-full bg-accent-500 md:h-7"></span>
          联系方式
        </h2>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
          <div className="flex items-center gap-3 rounded-lg border border-background-200/80 bg-background-50 p-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-mail-line text-xl"></i>
            </span>
            <div>
              <p className="text-xs text-secondary-500">联系邮箱</p>
              <p className="mt-0.5 text-sm font-medium text-foreground-900">contact@oumeisanji-demo.com</p>
            </div>
          </div>
          <div className="flex items-center gap-3 rounded-lg border border-background-200/80 bg-background-50 p-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-feedback-line text-xl"></i>
            </span>
            <div>
              <p className="text-xs text-secondary-500">意见反馈</p>
              <p className="mt-0.5 text-sm font-medium text-foreground-900">欢迎邮件反馈内容问题</p>
            </div>
          </div>
          <div className="flex items-center gap-3 rounded-lg border border-background-200/80 bg-background-50 p-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-time-line text-xl"></i>
            </span>
            <div>
              <p className="text-xs text-secondary-500">响应时间</p>
              <p className="mt-0.5 text-sm font-medium text-foreground-900">工作日 1-2 个工作日内回复</p>
            </div>
          </div>
        </div>
      </section>

      {/* 版权与免责声明 */}
      <section className="mt-10 md:mt-14">
        <h2 className="flex items-center gap-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-6 w-1 rounded-full bg-accent-500 md:h-7"></span>
          版权及免责声明
        </h2>
        <div className="mt-6 space-y-4 rounded-lg border border-background-200/80 bg-background-100 p-6 text-sm leading-relaxed text-foreground-700 md:p-8">
          <p>
            <strong className="text-foreground-950">一、内容性质。</strong>
            本站为内容资讯展示平台，站内所有影片资料、剧情介绍、图片与资讯内容均为演示用途的虚构示例，仅用于产品功能展示，不代表任何真实影视作品的完整信息。
          </p>
          <p>
            <strong className="text-foreground-950">二、不提供播放与下载。</strong>
            本站不提供任何影片的在线播放、下载、缓存或付费购买服务，也不存储任何影视资源文件。用户如需观看影视作品，请通过当地正规发行渠道获取正版内容。
          </p>
          <p>
            <strong className="text-foreground-950">三、版权归属。</strong>
            本站展示的文字与图形元素的知识产权归本平台所有。如站内演示内容无意中与第三方权益产生关联，请通过上述联系方式告知，我们将及时处理。
          </p>
          <p>
            <strong className="text-foreground-950">四、使用建议。</strong>
            请用户在遵守所在国家或地区法律法规及相关平台规则的前提下使用本站信息，理性、健康地欣赏影视内容。
          </p>
        </div>
      </section>

      <div className="mt-10 flex flex-wrap gap-3">
        <Link
          to="/category"
          className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
        >
          <i className="ri-grid-line"></i>
          浏览电影分类
        </Link>
        <Link
          to="/news"
          className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-newspaper-line"></i>
          查看影视资讯
        </Link>
      </div>
    </div>
  );
}